export const HOME = '/home'
export const LOGIN = '/login'
export const DOCUMENTATION = '/documentation'
export const ERROR_STATISTICS = '/error-statistics'
export const LOGOUT = '/logout'
export const USER_MANAGEMENT = '/user-management'
export const PROFILE = '/profile'
export const VERSION_MANAGEMENT = '/version-management'
export const VERSION_MANAGEMENT_VERSIONS = '/version-management/versions'
export const VERSION_MANAGEMENT_NEW_VERSION = '/version-management/new-version'
export const CUSTOMER_MANAGEMENT = '/customer-management'
export const CUSTOMER_MANAGEMENT_SHOW_CUSTOMER_INFORMATION = '/customer-information'
export const CUSTOMER_MANAGEMENT_SHOW_REMOTE_CONNECTIONS = '/remote-connections'
export const CUSTOMER_MANAGEMENT_SHOW_LICENCE_KEYS = '/licence-keys'
export const CUSTOMER_MANAGEMENT_SHOW_CUSTOMER_USERS = '/customer-users'
export const CUSTOMER_MANAGEMENT_SHOW_SCHEMA_COMPARES = '/schema-compares'
export const CUSTOMER_MANAGEMENT_SHOW_HARDWARE_COMPANY = '/hardware-company'
export const PERMISSIONS_MANAGEMENT = '/permission-management'
export const CUSTOMER_MANAGEMENT_SHOW_USER_COUNT = '/user-count'